import FavoriteCategoryNode from './FavoriteCategoryNode';
import FavoriteFolderNode from './FavoriteFolderNode';
import FavoritePersonaNode from './FavoritePersonaNode';
import FavoriteSearchNode from './FavoriteSearchNode';
import { observer } from 'owa-mobx-react';
import { favoritesStore } from 'owa-favorites';
import { type FolderForestNodeType } from 'owa-favorites-types';
import folderStore from 'owa-folders';
import publicFolderFavoriteStore from 'owa-public-folder-favorite/lib/store/publicFolderFavoriteStore';
import React from 'react';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export interface FavoriteNodeCommonProps {
    favoriteId: string;
    ellipsesOnHover?: boolean;
}

const FavoriteNode = observer(function FavoriteNode(props: FavoriteNodeCommonProps) {
    const id = props.favoriteId;
    if (favoritesStore.favoritesPersonaNodes.has(id)) {
        const personaNode = favoritesStore.favoritesPersonaNodes.get(id);

        if (!personaNode) {
            return null;
        }

        if (personaNode.mainEmailAddress) {
            if (
                !personaNode.personaId ||
                !personaNode.searchFolderId ||
                !personaNode.dropViewState
            ) {
                return null;
            }

            return (
                <FavoritePersonaNode
                    displayName={personaNode.displayName}
                    emailAddress={personaNode.mainEmailAddress}
                    personaId={personaNode.personaId}
                    searchFolderId={personaNode.searchFolderId}
                    dropViewState={personaNode.dropViewState}
                    isJustAdded={personaNode.isJustAdded}
                    isSearchFolderPopulated={personaNode.isSearchFolderPopulated}
                    mailboxInfo={getGlobalSettingsAccountMailboxInfo()}
                    ellipsesOnHover={props.ellipsesOnHover}
                    {...props}
                />
            );
        }
    } else if (favoritesStore.favoritesFolderNodes.has(id)) {
        const folderNode = favoritesStore.favoritesFolderNodes.get(id);
        const isPublicFolder = folderNode && folderNode.type === 5;
        const folder = isPublicFolder
            ? publicFolderFavoriteStore.folderTable.get(id)
            : folderStore.folderTable.get(id);

        if (folder) {
            return (
                <FavoriteFolderNode
                    folderId={id}
                    isPublicFolder={isPublicFolder}
                    ellipsesOnHover={props.ellipsesOnHover}
                    {...props}
                />
            );
        }
    } else if (favoritesStore.favoriteSearches.has(id)) {
        const favoriteSearch = favoritesStore.favoriteSearches.get(id);

        if (!favoriteSearch) {
            return null;
        }

        return (
            <FavoriteSearchNode
                searchQuery={id}
                dropViewState={favoriteSearch.dropViewState}
                mailboxInfo={getGlobalSettingsAccountMailboxInfo()}
                ellipsesOnHover={props.ellipsesOnHover}
                {...props}
            />
        );
    } else if (favoritesStore.favoriteCategories.has(id)) {
        const favoriteCategory = favoritesStore.favoriteCategories.get(id);

        if (!favoriteCategory) {
            return null;
        }

        return (
            <FavoriteCategoryNode
                categoryId={id}
                dropViewState={favoriteCategory.dropViewState}
                mailboxInfo={getGlobalSettingsAccountMailboxInfo()}
                ellipsesOnHover={props.ellipsesOnHover}
                {...props}
            />
        );
    }

    return null;
}, 'FavoriteNode');
export default FavoriteNode;
